// MuiTheme.jsx
import * as React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      light: "#123166",   // goia-navy-600
      main: "#091D42",    // goia-navy
      dark: "#05101F",    // goia-navy-800
      contrastText: "#FFFFFF",
    },
    secondary: {
      light: "#FCEAD0",   // goia-orange-100
      main: "#F09510",    // goia-orange
      dark: "#D07F00",    // goia-orange-600
      contrastText: "#FFFFFF",
    },
    success: {
      main: "#1E8E5A",
      light: "#E3F5EC",
      contrastText: "#FFFFFF",
    },
    error: {
      main: "#D64545",
      light: "#FBE7E7",
      contrastText: "#FFFFFF",
    },
    warning: {
      main: "#F09510",    // mesmo que secondary
      light: "#FCEAD0",
      contrastText: "#FFFFFF",
    },
    info: {
      main: "#1B7A8C",
      light: "#E1F1F3",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#FFFFFF",   // goia-bg
      paper: "#F5F6F8",     // goia-surface (para cards, papéis)
    },
    text: {
      primary: "#091D42",   // goia-text
      secondary: "#8A93A3", // goia-text-muted
    },
    divider: "#E4E7EC",     // goia-border
  },
  shape: {
    borderRadius: 8, 
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#091D42", // navy
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#FFFFFF",
          borderRight: "1px solid #E4E7EC",
        },
      },
    },
  },
});

export function MuiThemeProvider({ children }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}